import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=54459f0f&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"
import style0 from "./Loading.vue?vue&type=style&index=0&id=54459f0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54459f0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54459f0f')) {
      api.createRecord('54459f0f', component.options)
    } else {
      api.reload('54459f0f', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=54459f0f&scoped=true&", function () {
      api.rerender('54459f0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Components/Blocks/Loading.vue"
export default component.exports